export const GET_MISSIONS_BY_CITY_ID = 'GET_MISSIONS_BY_CITY_ID'
export const GET_MISSIONS_BY_CITY_ID_SUCCESS = 'GET_MISSIONS_BY_CITY_ID_SUCCESS'

export const GET_MISSIONS = 'GET_MISSIONS'
export const GET_MISSIONS_SUCCESS = 'GET_MISSIONS_SUCCESS'

export const GET_CAMPAIGN_MISSIONS = 'GET_CAMPAIGN_MISSIONS'
export const GET_CAMPAIGN_MISSIONS_SUCCESS = 'GET_CAMPAIGN_MISSIONS_SUCCESS'

export const UPDATE_MISSION = 'UPDATE_MISSION'
export const UPDATE_MISSION_SUCCESS = 'UPDATE_MISSION_SUCCESS'
export const CREATE_MISSION_PICKUP = 'CREATE_MISSION_PICKUP'
export const CREATE_MISSION_PICKUP_SUCCESS = 'CREATE_MISSION_PICKUP_SUCCESS'

export const UPDATE_MISSIONS_ALL = 'UPDATE_MISSIONS_ALL'
export const UPDATE_MISSIONS_ALL_SUCCESS = 'UPDATE_MISSIONS_ALL_SUCCESS'

export const GET_MISSION_BY_ID = 'GET_MISSION_BY_ID'
export const GET_MISSION_BY_ID_SUCCESS = 'GET_MISSION_BY_ID_SUCCESS'

export const GET_MISSION_BY_ID_GRAPH_QL = 'GET_MISSION_BY_ID_GRAPH_QL'
export const GET_MISSION_BY_ID_GRAPH_QL_SUCCESS =
  'GET_MISSION_BY_ID_SUCCESS_GRAPH_QL'

export const CREATE_MISSION = 'CREATE_MISSION'
export const CREATE_MISSION_SUCCESS = 'CREATE_MISSION_SUCCESS'

export const UNBOOK_MISSION_BY_ID = 'UNBOOK_MISSION_BY_ID'
export const UNBOOK_MISSION_BY_ID_SUCCESS = 'UNBOOK_MISSION_BY_ID_SUCCESS'
export const UNBOOK_MISSION_BY_ID_FAILURE = 'UNBOOK_MISSION_BY_ID_FAILURE'

export const SET_MISSIONS_LIST_FILTER = 'SET_MISSIONS_LIST_FILTER'

export const SET_MISSIONS_TYPE_FILTER = 'SET_MISSIONS_TYPE_FILTER'
export const SET_MISSIONS_DAY_PERIOD_FILTER = 'SET_MISSIONS_DAY_PERIOD_FILTER'
export const SET_MISSIONS_STATUS_FILTER = 'SET_MISSIONS_STATUS_FILTER'

export const SET_ROSTER_VIEW_MISSIONS_SORT_BY =
  'SET_ROSTER_VIEW_MISSIONS_SORT_BY'

export const APPLY_FILTERS = 'APPLY_FILTERS'
export const FETCH_SCHEDULED_PICKUPS = 'FETCH_SCHEDULED_PICKUPS'
export const FETCH_SCHEDULED_PICKUPS_SUCCESS = 'FETCH_SCHEDULED_PICKUPS_SUCCESS'

export const MISSIONS_FILTERS_DISPLAY_ALL = { label: 'All', value: null }

export const MISSIONS_DAY_FILTER_OPTIONS = [
  { label: 'All', value: null },
  { label: 'Mon', value: 'Mon' },
  { label: 'Tue', value: 'Tue' },
  { label: 'Wed', value: 'Wed' },
  { label: 'Thu', value: 'Thu' },
  { label: 'Fri', value: 'Fri' },
  { label: 'Sat', value: 'Sat' },
  { label: 'Sun', value: 'Sun' },
]

export const MISSIONS_TYPE_FILTER_OPTIONS = [
  { label: 'All', value: null },
  { label: 'Event / Weekend', value: 'weekend' },
  { label: 'Week Days', value: 'weekdays' },
]

export const MISSIONS_DAY_PERIOD_FILTER_OPTIONS = [
  { label: 'All', value: null },
  { label: 'Morning', value: 'morning' },
  { label: 'Lunch', value: 'lunch' },
  { label: 'Afternoon', value: 'afternoon' },
]

export const MISSIONS_STATUS_FILTER_OPTIONS = [
  { label: 'All', value: null },
  { label: 'Draft', value: 'draft' },
  { label: 'Available', value: 'available' },
  { label: 'Booked', value: 'booked' },
  { label: 'Checked-in', value: 'checked-in' },
  { label: 'Under review', value: 'under-review' },
  { label: 'Completed', value: 'completed' },
  { label: 'Cancelled', value: 'canceled' },
  { label: 'Paid', value: 'paid' },
]

export const MISSION_STATUS_BY_ORDER = {
  DRAFT: 0,
  AVAILABLE: 10,
  BOOKED: 20,
  CHECKEDIN: 30,
  UNDER_REVIEW: 35,
  COMPLETED: 40,
  CANCELLED: 50,
  PAID: 60,
}

export const MASTER_SCHEDULE_FILTERS = [
  {
    label: 'City',
    column: 'city',
    sorted: true,
  },
  {
    label: 'Week',
    column: 'week',
    sorted: true,
    ASC: false,
  },
  {
    label: 'Location',
    column: 'location',
    autoWidth: true,
    sorted: true,
  },
  {
    label: 'Status',
    column: 'status',
    sorted: true,
  },
]

export const CREATE_MISSIONS = 'CREATE_MISSIONS'
export const CREATE_MISSIONS_SUCCESS = 'CREATE_MISSIONS_SUCCESS'
export const CREATE_MISSIONS_FAILURE = 'CREATE_MISSIONS_FAILURE'

export const DELETE_MISSIONS = 'DELETE_MISSIONS'
export const DELETE_MISSIONS_SUCCESS = 'DELETE_MISSIONS_SUCCESS'
export const DELETE_MISSIONS_FAILURE = 'DELETE_MISSIONS_FAILURE'

export const PUBLISH_MISSIONS = 'PUBLISH_MISSIONS'
export const PUBLISH_MISSIONS_SUCCESS = 'PUBLISH_MISSIONS_SUCCESS'
export const PUBLISH_MISSIONS_FAILURE = 'PUBLISH_MISSIONS_FAILURE'



// WEBPACK FOOTER //
// ./src/Reducers/Mission/const.js